import React, { useState } from 'react';
import { Card } from './Card';

export function CardExample(): JSX.Element {
  const [cardElevation, setCardElevation] = useState(1);

  return (
    <Card elevation={cardElevation}>
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Quo amet, ipsa magni enim consequatur fugit eum officiis
      voluptatibus a odit eligendi? Ut laboriosam perspiciatis nihil nulla sit quidem vitae magni?
      <div style={{ marginTop: '20px' }}>
        <h3>Test card elevation</h3>
        <input type="number" value={cardElevation} onChange={(e) => setCardElevation(Number(e.target.value))} />
      </div>
    </Card>
  );
}
